import Tabs from './tabs';
import TabsRound, {TabsRoundOptionItem} from './tabs-round';

export * from './tabs';

export {TabsRound};
export type {TabsRoundOptionItem};
export default Tabs;
